import { Dialog, DialogPanel } from '@headlessui/react'
import { AnimatePresence, motion } from 'framer-motion'
import React, { PropsWithChildren } from 'react'

type Props = {
  show: boolean
  onClose: () => void
}

export default function SlideOutMenu({
  show,
  onClose,
  children,
}: PropsWithChildren<Props>) {
  return (
    <AnimatePresence initial={false}>
      {show && (
        <Dialog open={show} onClose={onClose}>
          <motion.div
            className="fixed inset-0 z-50 bg-white/20 backdrop-blur-md"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              ease: 'easeOut',
            }}
          />
          <div className="fixed inset-0 z-[51] flex items-end overflow-hidden">
            <motion.div
              className="absolute bottom-0 left-0 right-0 rounded-t-xl border-t border-gray-100 shadow-[0_0px_50px_rgba(0,0,0,0.30)]"
              initial={{ y: '100%' }}
              animate={{ y: 0 }}
              exit={{ y: '100%' }}
              transition={{
                ease: 'easeOut',
              }}
            >
              <DialogPanel className="h-full w-full bg-white py-7">
                {children}
              </DialogPanel>
            </motion.div>
          </div>
        </Dialog>
      )}
    </AnimatePresence>
  )
}
